import "../styles/Recipe.css";
import "../styles/Buttons.css";
import { useNavigate } from "react-router-dom";

import React from "react";

function TopNavbarBack(props) {
  const {
    title,
    rbuttonIcon,
    lbuttonIcon,
    rbackground,
    lbackground,
    rfunction,
    lfunction,
    lextra, // optional node shown next to the left button (e.g. an extra action)
  } = props;
  const navigate = useNavigate();
	const goBack = () => {
		navigate(-1);
	}

  return (
    <div className="spc-between topnav-container">
      <a onClick={goBack} className={rbackground}>
        {rbuttonIcon.map((icon, index) => (
          <div key={index}>
            <span className={icon}></span>
          </div>
        ))}
      </a>

      <p className="heading-1">{title}</p>

      {lextra ? (
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          {lextra}
          <a onClick={lfunction} className={lbackground}>
            {lbuttonIcon.map((icon, index) => (
              <div key={index}>
                <span className={icon}></span>
              </div>
            ))}
          </a>
        </div>
      ) : (
        <a onClick={lfunction} className={lbackground}>
          {lbuttonIcon.map((icon, index) => (
            <div key={index}>
              <span className={icon}></span>
            </div>
          ))}
        </a>
      )}
    </div>
  );
}

export default TopNavbarBack;